import { render, staticRenderFns } from "./LinkToAnchor.vue?vue&type=template&id=68584197&"
import script from "./LinkToAnchor.vue?vue&type=script&lang=js&"
export * from "./LinkToAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports